import {
  AUTH_USER,
  CLEAN_AUTH,
  AUTH_ERROR,
  FETCH_WORD_LEVEL_PROGRESS,
  LEVEL_UNLOCKED,
  FETCH_UNIT_LEVEL_PROGRESS,
  UNIT_LEVEL_UNLOCKED
} from "../actions/type";

const INIT_STATE = { user: null, errorMessage: "", isLogin: false };

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case AUTH_USER:
      return {
        ...state,
        user: payload.user,
        isLogin: true,
        errorMessage: ""
      };
    case CLEAN_AUTH:
      return { ...INIT_STATE };
    case AUTH_ERROR:
      return { ...state, errorMessage: payload };
    case FETCH_WORD_LEVEL_PROGRESS:
      return {
        ...state,
        user: {
          ...state.user,
          wordLevelProgress: payload
        }
      };
    case LEVEL_UNLOCKED:
      return {
        ...state,
        user: {
          ...state.user,
          wordLevelProgress: {
            ...(state.user?.wordLevelProgress || {}),
            [payload.booksetId]: payload.newMaxLevel
          }
        }
      };
    case FETCH_UNIT_LEVEL_PROGRESS:
      return {
        ...state,
        user: {
          ...state.user,
          unitLevelProgress: payload
        }
      };
    case UNIT_LEVEL_UNLOCKED:
      return {
        ...state,
        user: {
          ...state.user,
          unitLevelProgress: {
            ...(state.user?.unitLevelProgress || {}),
            [payload.bookId]: payload.newMaxUnitLevel
          }
        }
      };
    default:
      return state;
  }
};
